jQuery(document).ready(function($) {
    const $blocks = $('.wp-block-jormi-blocks-hero');
    if ($blocks.length === 0) return;

    $blocks.each(function() {
        const $block = $(this);
        const variant = $block.attr('data-variant');

        if (variant == 'blog') {
            const $swiper = $block.find('.swiper');
            if ($swiper.length) {                
                // Initialize the swiper within this specific block
                const swiper = new Swiper($swiper[0], {
                    slidesPerView: 1,
                    navigation: {
                        prevEl: '.swiper-button-prev',
                        nextEl: '.swiper-button-next'
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    spaceBetween: 16,
                    on: {
                        init: function() {
                            // Hide prev button on first slide
                            if (this.isBeginning) {
                                $block.find('.swiper-button-prev').hide();
                            }
                            // Hide next button on last slide
                            if (this.isEnd) {
                                $block.find('.swiper-button-next').hide();
                            }
                        },
                        slideChange: function() {
                            // Show/hide prev button
                            if (this.isBeginning) {
                                $block.find('.swiper-button-prev').hide();
                            } else {
                                $block.find('.swiper-button-prev').show();
                            }
                            
                            // Show/hide next button
                            if (this.isEnd) {
                                $block.find('.swiper-button-next').hide();
                            } else {
                                $block.find('.swiper-button-next').show();
                            }
                        }
                    }
                });
            }
        } else if (variant == 'fullscreen') {
            if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

            const $pinWrapper = $block.find('.pin-wrapper');
            const $graphicWrapper = $block.find('.graphic-wrapper');
            const graphic = $block.find('.graphic-wrapper svg');
            const $mediaWrapper = $block.find('.media-wrapper');
            const $media = $mediaWrapper.find('video,img')
            const textElems = $block.find('p,h1,h2,h3,h4,h5,h6,a');
            gsap.registerPlugin(ScrollTrigger);
            // Set initial states - text elements start visible
            gsap.set(textElems, {
                autoAlpha: 1,
                yPercent: 0
            });
            /**
             * On mobile, the .entry-content is pinned so that blocks/elements following the header is visible during scroll.
             * Otherwise, pinning $pinWrapper on mobile will create empty space and push any following elements down the page.
             */
            const viewportWidth = window.innerWidth;
            const isMobile = viewportWidth < 992;
            // Create timeline
            const mainTl = gsap.timeline({
                paused: true,
                scrollTrigger: {
                    trigger: $block,
                    start: 'top top',
                    end: '+=300%',
                    pin: isMobile ? $('.entry-content') : $pinWrapper,
                    pinSpacing: true,
                    scrub: 2,
                    // markers: true,
                }
            });
            // Animation sequence
            
            if (isMobile) { 
                mainTl
                // Fade out text elements
                .to(textElems, {
                    autoAlpha: 0,
                    yPercent: -30,
                    duration: 0.2,
                    ease: "sine.inOut"
                }, '<')
                // First animate the media wrapper to fill screen width
                .to($mediaWrapper, {
                    maxHeight: 'none',
                    width: '100vw',
                    height: '100%',
                    borderRadius: !isMobile && '0',
                    duration: 0.5,
                    ease: 'power2.inOut',
                }, '-=0.2')
                // Scale graphic in the background
                .to(graphic, {
                    scale: 2,
                    autoAlpha: 0,
                    duration: 0.5,
                    ease: "sine.inOut"
                }, '<')
                // First animate the media wrapper to fill screen height
                .to($mediaWrapper, {
                    width: '100%',
                    height: '80vh',
                    aspectRatio: '9 / 16',
                    borderRadius: '0',
                    duration: 0.3,
                    position: 'absolute',
                    bottom: '0',
                    ease: 'power2.inOut',
                })
                .to({}, {duration: 0.25});
            } else {
                mainTl
                // First animate the media wrapper
                .to($mediaWrapper, {
                    maxHeight: 'none',
                    width: '100vw',
                    height: '125vh',
                    borderRadius: '0',
                    duration: 0.8,
                    ease: 'power2.inOut',
                })
                // Scale graphic in the background
                .to(graphic, {
                    scale: 1.5,
                    autoAlpha: 0,
                    duration: 0.5,
                    ease: "sine.inOut"
                }, '<')
                // Fade out text elements
                .to(textElems, {
                    autoAlpha: 0,
                    yPercent: -30,
                    duration: 0.2,
                    ease: "sine.inOut"
                }, '<')
                .to({}, {duration: 0.25});
            }
            window.addEventListener('resize', () => {
                ScrollTrigger.refresh();
            })
        } else if (variant == 'gallery') {
            const $galleryGrid = $block.find('.gallery-grid');
            const $galleryCols = $galleryGrid.find('.gallery-col');
            const $figures = $galleryGrid.find('figure');

            gsap.set($galleryCols, {
                yPercent: 10,
                autoAlpha: 0
            })

            const mainTl = gsap.timeline({
                duration: 0.5,
            })

            mainTl.to($galleryCols, {
                yPercent: 0,
                autoAlpha: 1,
                stagger: 0.4,
                ease: 'power1.out',
            })

            function shuffleImages() {
                const allFigures = Array.from($figures);            
                const shuffledFigures = gsap.utils.shuffle([...allFigures]);
                
                $galleryCols.each(function(index, col) {
                    $(col).empty(); // clear col
                    // assign images to col
                    const figuresPerCol = 2;
                    const startIdx = index * figuresPerCol;
                    const colFigures = shuffledFigures.slice(startIdx, startIdx + figuresPerCol);
                    colFigures.forEach(fig => {
                        $(col).append(fig); 
                    });
                });
            }

            // Function to trigger fade-out, shuffle, and reappear animation
            function resetAnimation() {
            const resetTl = gsap.timeline();
            resetTl
                .to($galleryCols, {
                    yPercent: -10,
                    autoAlpha: 0,
                    stagger: 0.2,
                    ease: "power1.in",
                    onComplete: shuffleImages,
                })
                .set($galleryCols, {
                    yPercent: 10 }
                )
                .to($galleryCols, {
                    yPercent: 0,
                    autoAlpha: 1,
                    stagger: 0.40,
                    ease: "power1.out",
                });
            }
            setInterval(resetAnimation, 7000);
        }
    });
});